export enum GiftCardConfigurationTypeEnum {
  defaultCardType = 'Default Card Type',
  giftCardTransfersEnabled = 'Gift Card Transfers Enabled',
  replyToEmail = 'Reply To Email',
  ccEmail = 'CC Email',
  issuingMerchant = 'Issuing Merchant',
  redeemDisabledMerchants = 'Redeem Disabled Merchants',
  extraLicenseKeys = 'Extra License Keys',
  transferFromProvider = 'Transfer From Provider',
  automaticExternalProcessingEnabled = 'Automatic External Processing Enabled',
  automaticExternalProcessing = 'Automatic External Processing',
}
